import { filteredGoogleFonts } from "./filteredGoogleFonts";

export function getStyleImportForGoogleFont(fontFamily) {
    if (!fontFamily) {
        return "";
    }

    switch (fontFamily) {
        case "Roboto":
            return "@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;1,100;1,300;1,400;1,500;1,700&display=swap'); ";
        case "Open Sans":
            return "@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..600;1,300..600&display=swap'); ";
        case "Noto Sans JP":
            return "@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..600&display=swap'); ";
        case "Montserrat":
            return "@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..600;1,100..600&display=swap'); ";
        case "Poppins":
            return "@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;1,100;1,200;1,300;1,400;1,500;1,600&display=swap'); ";
        case "Redacted Script":
            return "@import url('https://fonts.googleapis.com/css2?family=Redacted+Script:wght@300;400;700&display=swap'); ";
        default:
            return "";
    }
}

function getStyleImportForTopGoogleFonts(numFonts) {
    const fonts = filteredGoogleFonts.items.slice(0, numFonts);
    fonts.push(filteredGoogleFonts.items[filteredGoogleFonts.items.length - 1]);
    return {
        css: fonts.map((fontEntry) => getStyleImportForGoogleFont(fontEntry.family)).join("\n"),
        fonts
    };
}

export function loadFonts(numFonts = 5) {
    const style = document.createElement("style");
    const { css, fonts } = getStyleImportForTopGoogleFonts(numFonts);
    style.innerHTML = css;
    document.head.appendChild(style);
    return fonts.map((font) => font.family);
}
